import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";

/**
 * Product Routes and Pages
 */
const ListTopicPage = React.lazy(() => import("./ListTopicPage"));
const AddTopicPage = React.lazy(() => import("./AddTopicPage.js"));
const EditTopicPage = React.lazy(() => import("./EditTopicPage"));

const TopicRoutes = () => {
  return (
    <Routes>
      <Route index exact path="/list" element={<ListTopicPage />} />
      <Route path="*" element={<Navigate replace to="/404" />} />
      <Route exact path="/add" element={<AddTopicPage />} />
      <Route exact path="/edit/:id" element={<EditTopicPage />} />
    </Routes>
  );
};

export default TopicRoutes;
